import React from 'react';

import { Button, Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export * from './base.styled';

export const DetailsBox = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.detailsBox, style] });

export const TextStyled = withTypography({
  variant: 'copyOne',
  fontSize: 'md',
});

export const FieldContainer = ({ accessible = true, style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    accessible,
    style: [styles.fieldContainer, style],
  });

export const PickupTimeHeadingContainer = ({ focusable = true, style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    focusable,
    style: [styles.pickupTimeHeadingContainer, style],
  });

export const PickupDetailsBox = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pickupDetailsBox, style] });

export const DetailsWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.detailsWrapper, style] });

export const IconStyled = Icon.withConfig({
  size: 5,
  marginRight: '$1',
});

export const ServiceModesFooter = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.serviceModesFooter, style] });

export const ChangeServiceModeButton = Button.withConfig<{ isDesktopWeb: boolean }>(props => ({
  minWidth: props.isDesktopWeb ? '$18' : '$16',
  padding: '$2',
  paddingLeft: props.isDesktopWeb ? '$4' : '$3',
  paddingRight: props.isDesktopWeb ? '$4' : '$3',
}));

const styles = StyleSheet.create({
  detailsBox: {
    backgroundColor: getDesignToken('background-card'),
    borderRadius: primitive.$borderRadius,
    marginTop: spacing.$5,
    paddingHorizontal: spacing.$6,
    paddingVertical: spacing.$5,
    shadowColor: primitive.$shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowOpacity: 1,
    shadowRadius: 1.5,
  },
  detailsWrapper: {
    alignItems: 'center',
    backgroundColor: primitive.$white,
    borderRadius: 10,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: spacing.$4,
  },
  fieldContainer: {
    marginBottom: spacing.$4,
  },
  pickupDetailsBox: {
    borderRadius: primitive.$borderRadius,
    marginTop: spacing.$5,
  },
  pickupTimeHeadingContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    margin: spacing.$0,
    marginHorizontal: spacing.$4,
  },
  serviceModesFooter: {
    backgroundColor: primitive.$blackOpacity4,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$1,
  },
});
